<template>
  <b-card
    title="مدیریت تظیمات سایت"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <!--              <b-button-->
              <!--                  class="mb-1 ml-1"-->
              <!--                  variant="primary"-->
              <!--                  @click="addState()"-->
              <!--              >-->
              <!--                جدید-->
              <!--              </b-button>-->
              <b-button
                variant="success"
                class="mb-1 mr-auto ml-1"
                @click="clearCache"
              >
                بروزرسانی
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="updateSiteSetting(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link @click="updateSiteSetting(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <!--              <feather-icon-->

              <!--                  icon="TrashIcon"-->
              <!--                  size="16"-->
              <!--                  class="ml-1 cursor-pointer"-->
              <!--                  @click="remove(data.item.Id)"-->
              <!--              />-->
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showSiteSettingModal"
      v-model="showSiteSettingModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      :title="row.Title"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="save"
    >

      <b-col
        md="12"
        class="mt-1"
        v-if="row.Type == 0"
      >
        <b-form-group
          label-for="Description"
        >
          <b-form-textarea
            id="Description"
            v-model="row.Description"
            name="Description"
            rows="8"
          />
        </b-form-group>
      </b-col>

      <b-col
          class="mt-1"
          cols="12"
          v-else-if="row.Type == 1"
      >
        <b-media class="mb-2">
          <template #aside>
            <b-avatar
                ref="previewEl"
                :src="row.Description"
                size="90px"
                rounded
                button
                @click="$refs.refInputEl.click()"
            />
          </template>
          <input
              :ref="'refInputEl'"
              type="file"
              class="d-none"
              name="Image"
              @input="imageRenderer($event)"
          >
        </b-media>
      </b-col>

    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'State',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        Type: 0,
      },
      showSiteSettingModal: false,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.sitesetting.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
        this.$api.sitesetting.clearcache, null,
      )
        .then(res => {
          this.update()
        })
    },
    save() {
      let url = this.$api.sitesetting.add
      if (this.row.Id) {
        url = this.$api.sitesetting.update
      }

      this.$http.post(
        url, this.row,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showSiteSettingModal = true
        })
    },
    updateSiteSetting(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.showSiteSettingModal = true
    },
    imageRenderer(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          // ذخیره عکس به صورت base64 در row.Description
          this.row.Description = e.target.result;

          // برای نمایش پیش‌نمایش می‌توانید این خط را نیز اضافه کنید
          this.$refs.previewEl.src = e.target.result;
        };

        reader.readAsDataURL(file);
      }
    }
  },
}
</script>

<style scoped>

</style>
